import React from "react";
import img from "../../Layouts/sm.png";

function AboutImg() {
    return <img src={img} alt="Artwork" className="about__img" />;
}

export default AboutImg;
